/**
 * Check JSON response for status and content-type header. Return empty object if not valid json.
 * @param {Response} response - The fetch response to check
 * @returns {Promise<Object>} Parsed JSON object or empty object if invalid
 */
async function checkJSONResponse(response) {
    if (!response.ok) {
        return {};
    }
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
        return response.json();
    }
    return {};
}

/**
 * Fetch data from a URL and handle errors gracefully.
 * Return an empty object if the fetch fails or the response is not valid JSON.
 * @param url
 * @param options
 * @returns {Promise<Object|{}>}
 */
async function safeFetch(url, options = {}) {
    try {
        const response = await fetch(url, options);
        return await checkJSONResponse(response);
    } catch (error) {
        console.error('Fetch error:', error);
        return {};
    }
}

export { checkJSONResponse, safeFetch };